module.exports = __webpack_public_path__ + "static/media/full_stack_project.4bbae123.svg";